<template>
  <div
    id="course-detail"
    class="courseDetails safe-distance-top-header"
    :class="{ 'safe-distance-bottom-tool': !isShelves }"
  >
    <detail-header :pageTitle="title" :shareInfo="shareInfo"></detail-header>
    <Shelves v-if="isShelves" />
    <div v-else>
      <div>
        <!-- 页面滚动之后出现顶部导航  -->
        <anchor-scroll-nav
          v-if="tabsTitle.length > 1"
          :tabsTitleList="tabsTitle"
          anchorFlag=".anchor-box"
          faBoxId="course-detail"
        ></anchor-scroll-nav>
        <!-- 1.顶部图片 100%宽 -->

        <!-- v-if -->
        <div class="top-img" v-if="isPlay" style="z-index: 98">
          <div id="J_prismPlayer"></div>
        </div>

        <!--  v-else  -->
        <div class="img" v-else>
          <img :src="$global.imgUrl + cover" alt="" />
        </div>

        <!-- 2.主体内容 区域，统一设置边距-->
        <div :class="['content', {'playheight': isPlay}]">
          <!-- 2.1会议基本信息（名称时间等） -->
          <div class="content-box meeting-info" ref="meetinginfo">
            <!-- 价格 -->
            <span class="price" v-show="minPrice === maxPrice"
              >¥{{ minPrice }}</span
            >
            <span class="price" v-show="minPrice !== maxPrice"
              >¥{{ minPrice }}-{{ maxPrice }}</span
            >
            <!-- 标题 -->
            <h3 class="title">{{ title }}</h3>
            <!-- 时间 -->
            <p class="time">
              <span>总时长:{{ totalHours }}小时</span>
            </p>
            <!-- 位置 -->
            <p class="address">
              <span
                >开课时间:{{
                  startType === "随报随学" ? "随报随学" : beginTime
                }}</span
              >
            </p>
            <!-- 有效期 -->
            <p class="address">
              <span>有效期:{{ validTimeShow }}</span>
            </p>
          </div>
          <!-- 2.2 会议详情 富文本回显-->
          <div
            class="content-box detail-info anchor-box"
            name="详情"
            v-if="articleContent"
          >
            <h1>课程详情</h1>
            <div class="detail-info-box" v-html="articleContent"></div>
          </div>
          <!-- 2.3课程目录 -->
          <div
            class="content-box directory anchor-box"
            name="目录"
            v-if="directory_list.length"
          >
            <h1>课程目录</h1>
            <van-collapse v-model="activeNames">
              <template v-for="(item, index) in directory_list">
                <van-collapse-item :key="index" :title="item.name" :name="item.key" v-if="!item.videoId">
                  <template v-if="item.childrenList && item.childrenList.length">
                    <div
                      :class="['video-item', { 'is-active': activeVideo === subItem.key }]"
                      v-for="subItem in item.childrenList"
                      :key="subItem.videoId"
                      @click="videoClick(subItem)">
                      <div class="video-title">
                        {{ subItem.name }}
                      </div>
                    </div>
                  </template>
                </van-collapse-item>
                <div
                  :class="['video-item', { 'is-active': activeVideo === item.key }]"
                  style="padding: 0 17px"
                  @click="videoClick(item)"
                  :key="index"
                  v-else>
                  <div class="video-title">{{ item.name }}</div>
                </div>
              </template>
            </van-collapse>
          </div>
          <!-- 2.4 讲师介绍 -->
          <div
            class="content-box committee-info anchor-box"
            name="讲师"
            v-if="lecturer_list.length"
          >
            <h1>讲师介绍</h1>
            <div>
              <!-- 循环组委会成员信息： 点击可跳转至对应学者百家号 -->
              <ul>
                <li
                  class="committee-member"
                  v-for="item in lecturer_list"
                  :key="item.id"
                  @click="committeeMember(item.userId)"
                >
                  <div class="member-basic-info">
                    <img
                      v-lazy="$global.imgUrl + item.headImg"
                      alt=""
                      class="personal-img"
                    />
                    <div>
                      <p>
                        <span class="member-name">{{ item.userName }}</span>
                        <!-- 成员title多个 -->
                        <label
                          class="member-title"
                          v-for="i in item.titles.filter(i=> i.levelTwo)"
                          :key="i.id"
                          >{{ i.levelTwo }}</label
                        >
                      </p>
                      <p class="member-education-info">
                        {{ item.researchDirection }}
                      </p>
                    </div>
                  </div>
                  <div class="member-intro">
                    {{ item.profile }}
                  </div>
                </li>
              </ul>
            </div>
            <!-- <div v-else class="empty-data content-box">
              <img class="zanwu-img" src="@/assets/img//mobile-img/zanwu.png" alt="">
              <p class="zanwu-text">暂无讲师介绍</p>

            </div> -->
          </div>
          <!-- 2.5 课程资料 -->
          <div
            class="content-box conference-proceedings anchor-box"
            name="资料"
            v-if="fileList.length"
          >
            <h1>课程资料</h1>
            <div>
              <!-- 循环资料列表，点击能下载 @click -->
              <ul>
                <li
                  v-for="item in fileList"
                  :key="item.id"
                  @click="downloadFile(item.url, item.fileName)"
                >
                  {{ item.fileName }}
                </li>
              </ul>
            </div>
            <!-- <div v-else class="empty-data content-box">
              <img class="zanwu-img" src="@/assets/img//mobile-img/zanwu.png" alt="">
              <p class="zanwu-text">暂无课程资料</p>

            </div> -->
          </div>
          <!-- 2.6 金融研修学院链接 -->
          <div class="content-box college-of-finance" @click="jump">
            <img
              v-if="business.headImg"
              :src="$global.imgUrl + business.headImg"
              alt=""
            />
            <img
              v-else
              src="../../../../assets/mylogin/default-JG.png"
              alt=""
            />
            <div class="businessName" v-html="business.name"></div>
            <button>查看</button>
          </div>
          <!-- 2.7机构其他课程 -->
          <div
            class="content-box other anchor-box"
            name="推荐"
            v-if="course_list.length"
          >
            <h1>机构其他课程</h1>
            <div>
              <div
                class="course_list"
                v-for="item in course_list"
                :key="item.id"
                @click="otherDetails(item.id)"
              >
                <img
                  class="px-cover-img"
                  v-lazy="`${$global.imgUrl}${item.albumPics}`"
                  alt=""
                />
                <div class="px-content">
                  <h5 class="px-title" v-html="item.goodsName"></h5>
                  <div class="px-address">
                    <img src="@/assets/mylogin/px-address-icon.png" alt="" />
                    <span v-html="item.shopName"></span>
                  </div>
                  <div class="px-info">
                    <div class="price">
                      {{ item.isFree === 1 ? "收费" : "免费" }}
                    </div>
                    <div class="isSign">3人已报名</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div v-else class="empty-data content-box">
              <img class="zanwu-img" src="@/assets/img//mobile-img/zanwu.png" alt="">
              <p class="zanwu-text">暂无其他课程</p>

            </div> -->
          </div>
          <!-- 3.底部分享收藏点击报名 -->
          <footer-toolbar
            title="课程"
            :shareInfo="shareInfo"
            @sharePoster="sharePoster"
          >
            <!-- 分享面板右侧按钮 -->
            <template #right>
              <van-button v-if="isSale === 1" disabled type="info" :round="true">已停售</van-button>
              <div v-else>
                <div v-if="isAvailable === 0">
                    <!-- 课程超过报名日期 -->
                    <van-button disabled type="info" :round="true">课程已结束</van-button>
                </div>
                <div v-else-if="isAvailable === 1">
                  <!-- 已报名线下课程 -->
                  <van-button v-if="isUserExist === 1" disabled type="info" :round="true"
                    >已报名</van-button
                  >
                  <van-button v-else-if="isUserExist === 2" type="info" :round="true" @click="meetingSignup"
                    >已到期，继续学习</van-button
                  >
                  <van-button v-else type="info" :round="true" @click="meetingSignup"
                    >立即报名</van-button
                  >
                </div>
              </div>
            </template>
          </footer-toolbar>
          <!-- 4.sku面板 -->
          <goods-sku
            v-if="showSku"
            :showSku="showSku"
            :sku="sku"
            :goods="goods"
            :initial-sku="initialSku"
            buyText="立即报名"
            :hideStock="true"
            @handleBuy="signUp"
            @updateSkuPannelStatus="updateSkuPannelStatus"
          ></goods-sku>
        </div>
      </div>
      <ExtendTool
        :hasExtend="hasExtend"
        :shareInfo="shareInfo"
        @sharePoster="(showStatus) => sharePoster(showStatus, true)"
      />
      <!-- 生成海报及海报分享 遮罩 -->
      <van-overlay
        class="poster-overlay"
        :lock-scroll="true"
        :show="showPoster"
        @click="restorePageScroll"
        @touchmove.prevent
        @mousewheel.prevent
      >
        <div class="wrapper">
          <!-- 会议和课程使用一个模板  -->
          <div
            class="meeting-course"
            style="
              width: 100vw;
              height: 100vh;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
            "
          >
            <!-- <div id="poster" ref="poster"></div> -->
            <img
              id="poster"
              v-if="posterUrl"
              width="315"
              height="356"
              ref="poster"
              :src="posterUrl"
              alt=""
              crossOrigin="anonymous"
            />
          </div>
        </div>

        <div
          class="poster-html"
          v-show="showPoster"
          style="opacity: 0; pointer-events: none"
        >
          <!-- 会议和课程海报 -->
          <div id="poster-dom" class="poster-meeting-course">
            <div class="poster-content">
              <img class="cover" :src="$global.imgUrl + cover" alt="" />

              <h1 class="title" v-html="tempTitle"></h1>
              <h2 class="price">
                <span class="price" v-show="minPrice === maxPrice"
                  >¥{{ minPrice }}</span
                >
                <span class="price" v-show="minPrice !== maxPrice"
                  >¥{{ minPrice }}-{{ maxPrice }}</span
                >
              </h2>
            </div>

            <div class="poster-bottom">
              <div class="qr-code-area">
                <div ref="qrcode" id="qrcode"></div>
                <span>长按识别二维码</span>
              </div>
              <img
                src="@/assets/img/mobile-img/zw-logo.png"
                alt=""
                class="logo"
              />
            </div>
          </div>
          <!-- <div v-else-if="title == '图书'">
            <div id="poster-dom">
              <div clas="book-cover"><img src="" alt="" /></div>
              <div class="book-info">
                <h1 class="book-title">美好生活：中产阶级美好生中产阶级中产阶级</h1>
                <h2 class="book-price">¥1388</h2>
              </div>
              <div class="poster-bottom">
                <div class="qr-code-area">
                  <div ref="qrcode" id="qrcode"></div>
                  <span>长按识别二维码</span>
                </div>
                <img src="@/assets/img/mobile-img/zw-logo.png" alt="" class="logo" />
              </div>
            </div>
          </div>
          <div v-else-if="title == '百科号' || title == '百家号' || title == '机构号'" id="poster-dom"></div> -->
        </div>
      </van-overlay>
    </div>
  </div>
</template>

<script>
import DetailHeader from "@/views/mobileView/detail/components/detailHeader.vue";
import AnchorScrollNav from "@/views/mobileView/detail/components/anchorScrollNav.vue";
import FooterToolbar from "@/views/mobileView/detail/components/bottomTool.vue";
import ExtendTool from "@/views/mobileView/detail/components/extendTool.vue";
import GoodsSku from "@/views/mobileView/detail/components/goodsSku.vue";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import Shelves from "@/views/mobileView/detail/components/shelves.vue";
import { Toast } from "vant";
export default {
  name: "courseDetails",
  data() {
    return {
      active: "1",
      //开课时间
      beginTime: "",
      //有效期展示
      validTimeShow: "",
      // 登录人是否已报名参加当前课程(0未报名 1已报名 2已过期)
      isUserExist: null,
      //当前课程是否可参加 0不可用 1可用 (是否在有效期内)
      isAvailable: 0,
      // 默认显示图片
      cover: "",
      // 当前颜色
      currentIndex: 0,
      // 下载路径
      downloadurl: "http://47.93.50.49:8292/",
      show: false,
      // 最大价格
      maxPrice: "",
      // 最小价格
      minPrice: "",
      // 标题
      title: "",
      // 总课时
      totalHours: "",
      // 有效期
      validType: "",
      // 开课类型
      startType: "",
      // 课程目录
      directory_list: [],
      // 机构其他课程
      course_list: [],
      // 课程详情页
      articleContent: "",
      // 视频id
      videoId: "",
      // 播放url
      playURL: "",
      // 讲师介绍
      lecturer_list: [],
      // 课程资料
      fileList: [],
      // 商家信息
      business: {},
      // 授课机构
      userType: "",
      showSku: false,
      tabsTitle: [
        {
          anchorName: "详情",
          active: true,
          show: false,
        },
        {
          anchorName: "目录",
          active: false,
          show: false,
        },
        {
          anchorName: "讲师",
          active: false,
          show: false,
        },
        {
          anchorName: "资料",
          active: false,
          show: false,
        },
        {
          anchorName: "推荐",
          active: false,
          show: false,
        },
      ],

      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [
          {
            k: "票种", // skuKeyName：规格类目名称
            k_s: "s1", // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
            v: [
              {
                id: "1", // skuValueId：规格值 id
                name: "免费票", // skuValueName：规格值名称
                // imgUrl: require("@/assets/img/details/bkqktg.png"), // 规格类目图片，只有第一个规格类目可以定义图片
                // previewImgUrl: require("@/assets/img/details/bkqktg.png"), // 用于预览显示的规格类目图片
              },
            ],
          },
        ],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [
          {
            id: 1, // skuId
            s1: "1", // 规格类目 k_s 为 s1 的对应规格值 id
            s2: "1", // 规格类目 k_s 为 s2 的对应规格值 id
            price: 110, // 价格（单位分）
            stock_num: 110, // 当前 sku 组合对应的库存
            desc: "组合110商品描述",
          },
        ],
        price: "", // 默认价格（单位元）
        stock_num: 0, // 商品总库存
        collection_id: null, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无规格商品

        hide_stock: true, // 是否隐藏剩余库存
      },
      initialSku: {
        s1: "1",
        s2: "1",
        // 初始选中数量
        selectedNum: 1,
      },
      goods: {
        // 默认商品 sku 缩略图
        picture: require("@/assets/img/mobile-img/yanxiuxueyuanlogo.png"),
      },
      // 视频
      player: null,
      companyId: "",
      // sku商品相关
      goodsc: {},
      goodsSkuInfosDtoc: {},
      shopsInfoDto: {},
      // 规格信息
      courseList: [],
      // 商品姓名
      goodsName: "",
      // 分享内容
      shareInfo: {},
      // 如果当前详情接口返回指定code,标识下架
      isShelves: false,
      // 海报overlay
      showPoster: false,
      posterUrl: "",
      qrcode: null,
      // 海报模板中标题数据（如果涉及文本省略号，需JS处理，否则htmltocanvas无法显示省略号
      tempTitle: "",
      extendShow: false,
      hasExtend: false,
      activeNames: [], // 章节展开项
      activeVideo:'', // 目录选中的视频
      curriculumType: null, // 课程类型 1线上课程 2线下课程
      isPlay: false, // 是否播放视频
      isSale: 0, // 是否停售 0 未停售，1 已停售
      isBegin: true, // 课程是否开始
    };
  },
  components: {
    DetailHeader,
    AnchorScrollNav,
    FooterToolbar,
    GoodsSku,
    Shelves,
    ExtendTool,
  },
  created() {
    this.courseDetails();
  },
  methods: {
    meetingSignup() {
      // 判断当前用户是否登录，
      this.$preventFun.Debounce(() => {
        if (sessionStorage.getItem("token")) {
          this.showSku = true;
        } else {
          if (this.$route.query.out) {
            if (this.$global.isAndroid_ios()) {
              window.android.getToken();
            } else {
              window.webkit.messageHandlers.getToken.postMessage("null"); //ios
            }
          } else {
            // 如果未登录，跳转登录页
            // 记录源网页，登录成功之后跳转回当前页面
            this.$router.push("/logins");
          }
        }
      })();
    },
    // 获取课程详情接口
    async courseDetails() {
      const resp = await this.$apis.goodsServe.courseDetails({
        type: 9,
        goodsId: this.$route.query.goodsId,
        isFrontEnd: 1,
      });
      if (resp.resultCode == 200) {
        this.$addStorageEvent("isCollect", resp.data.isCollect === 0);
        // 给APP分享需要的内容
        this.shareInfo = {
          title: resp.data.curriculum.title,
          cover: resp.data.curriculum.cover,
          articleId: resp.data.content.articleId,
          articleType: resp.data.content.articleType,
          goodsId: this.$route.query.goodsId,
          goodsTypeId: resp.data.goodsDto.goods.goodsTypeId,
          price:
            resp.data.minPrice == resp.data.maxPrice
              ? `${resp.data.minPrice}`
              : `${resp.data.minPrice}-${resp.data.maxPrice}`,
          saleType: resp.data.curriculum.saleType,
        };
        // 微信分享参数
        this.$global.toShare(
          resp.data.curriculum.title,
          "",
          resp.data.curriculum.cover
        );
        this.maxPrice = resp.data.maxPrice;
        this.minPrice = resp.data.minPrice;
        this.title = resp.data.goodsDto.goods.goodsName;
        // 海报单行显示标题，htmltocanvas手动处理文本溢出省略号，暂时固定单行15个字显示
        this.tempTitle =
          this.title.length > 15
            ? this.title.substring(0, 16) + "..."
            : this.title;
        this.totalHours = resp.data.curriculum.totalHours;
        if (resp.data.curriculum.validType === 1) {
          this.validType = "长期有效";
          this.validTimeShow = "长期有效";
        } else if (resp.data.curriculum.validType === 2) {
          this.validType = "自定义时间";
          this.validTimeShow = `购买后${resp.data.curriculum.expirationDay}天有效`;
        } else if (resp.data.curriculum.validType === 3) {
          this.validType = "固定到期时间";
          this.validTimeShow = resp.data.curriculum.validEndTime + "前有效";
        }
        if (resp.data.curriculum.startType === 1) {
          this.startType = "随报随学";
        } else if (resp.data.curriculum.startType === 2) {
          this.startType = "自定义时间";
        }
        this.beginTime = resp.data.curriculum.beginTime;
        // 处理课程列表数据
        this.setKey(resp.data.directoryList);
        this.directory_list = resp.data.directoryList;
        this.course_list = resp.data.goodsDto.goodsList ? resp.data.goodsDto.goodsList : [];
        this.articleContent = resp.data.content.articleContent;
        this.isUserExist = resp.data.isUserExist
        this.isAvailable = resp.data.isAvailable
        this.curriculumType = resp.data.curriculum.curriculumType
        this.isSale = resp.data.goodsDto.isSale
        // 计算课程是否开始
        if (resp.data.curriculum.beginTime) {
          let time = new Date(resp.data.curriculum.beginTime).getTime();
          let current = Date.now();
          this.isBegin = current > time;
        }
        this.lecturer_list = resp.data.lecturerVoList;
        this.fileList = resp.data.fileList;
        // 根据内容有无更新顶部导航项
        this.updateTabsList();
        this.getUser(
          resp.data.curriculum.userType,
          resp.data.curriculum.createUser,
          resp.data.curriculum.companyId
        );
        this.companyId = resp.data.curriculum.companyId;
        this.userType = resp.data.curriculum.userType;
        this.goodsName = resp.data.goodsDto.goods.goodsName;
        this.cover = resp.data.curriculum.cover;
        // sku数据
        this.goodsc = resp.data.goodsDto.goods;
        this.goodsSkuInfosDtoc = resp.data.goodsDto.goodsSkuInfosDto;
        this.shopsInfoDto = resp.data.goodsDto.shopsInfoDto;
        this.hasExtend = resp.data.goodsDto.goods.isPromotionGoods === 1;
        // 处理sku数据格式
        var skuDataObj = this.$global.formatGoodsDataToVantSku(
          {
            goods: this.goodsc,
            goodsList: this.course_list,
            goodsSkuInfosDto: this.goodsSkuInfosDtoc,
            shopsInfoDto: this.shopsInfoDto,
          },
          this.minPrice,
          this.maxPrice
        );
        this.sku = skuDataObj.sku;
        this.goods = skuDataObj.goods;
        this.initialSku = skuDataObj.initialSku;
        // 判断是视频还是图片
        // if (this.isUserExist === 1 && this.playURL) {
        //   let element = this.$refs.meetinginfo;
        //   element.style.marginTop = "275px";
        // }
        // 线上课程录播视频自动播放
        this.setDefaultPlay();
      } else if (
        resp.resultCode === "10401002" ||
        resp.resultCode === "10401001"
      ) {
        this.isShelves = true;
      } else {
        this.$Message.warning(resp.resultDesc);
      }
    },
    // 根据各模块有无内容，决定是否显示顶部锚点导航项
    updateTabsList() {
      if (this.articleContent) this.tabsTitle[0].show = true;
      if (this.directory_list.length) this.tabsTitle[1].show = true;
      if (this.lecturer_list.length) this.tabsTitle[2].show = true;
      if (this.fileList.length) this.tabsTitle[3].show = true;
      if (this.course_list.length) this.tabsTitle[4].show = true;
      // 导航项可见模块名
      this.tabsTitle = this.tabsTitle.filter((item) => {
        return item.show == true;
      });
    },
    async getPlayInfos(videoId) {
      if (this.isUserExist && this.isUserExist === 1) {
        const res = await this.$apis.goodsServe.getPlayInfos({
          videoIds: videoId,
        });
        if(res.resultCode === '200') {
          res.data.forEach((item) => {
            this.playURL = item.playInfo;
          });
          this.player = new Aliplayer({
            id: "J_prismPlayer",
            source: this.playURL, //播放地址，可以是第三方点播地址，或阿里云点播服务中的播放地址。
          });
        } else {
          Toast(res.resultDesc);
        }
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }

      // this.player.on("ended", endedHandle);
    },
    // 设置默认播放
    setDefaultPlay() {
      if (this.isUserExist === 1 && this.directory_list.length && this.curriculumType === 1 && this.isBegin) {
        this.isPlay = true
        for (let i = 0; i < this.directory_list.length; i++) {
          let item = this.directory_list[i];
          if (item.videoId) {
            this.getPlayInfos(item.videoId);
            this.activeVideo = item.key;
            break;
          }
          if (!item.videoId) {
            if (item.childrenList && item.childrenList.length) {
              this.getPlayInfos(item.childrenList[0].videoId);
              this.activeNames.push(item.key);
              this.activeVideo = item.childrenList[0].key;
              break;
            }
          }
        }
      }
    },
    signUp(skuData) {
      var params = {};
      // 规格id
      // params.specifications = skuData.selectedSkuComb.specifications;
      // 调取生成订单所需要的参数
      params.id = skuData.selectedSkuComb.id;
      params.num = skuData.selectedNum;
      if (this.$route.query.promoterId) {
        params.promoterId = this.$route.query.promoterId;
      }
      this.courseList.push(params);

      console.log("--------------------", skuData);
      // 跳转到确认订单页回显参数
      var information = {};
      information.selectedNum = skuData.selectedNum;
      information.pictureUrl = skuData.pictureUrl;
      information.selectedText = skuData.selectedText.replace("已选：", "");
      information.id = skuData.selectedSkuComb.id; // skuID 商品规格id
      information.shopsName = this.shopsInfoDto.shopsName;
      information.skuPrice = skuData.selectedSkuComb.skuPrice;
      information.goodsName = this.goodsName;
      // 将所需要数据之后存储至localStorage （避免页面下一级页面所刷新导致数据丢失）
      localStorage.setItem("courseDetails", JSON.stringify(information));
      localStorage.setItem("courseParameter", JSON.stringify(this.courseList));

      // 跟APP联调
      if (this.$route.query.out) {
        // app端统一获取商品数据字段名
        information.goodsTitle = information.goodsName;
        information.skuId = skuData.selectedSkuComb.id;

        var appBookParams = {
          skuData: information,
          // 课程2
          type: 2,
        };
        if (this.$global.isAndroid_ios()) {
          window.android.confirmOrder(JSON.stringify(appBookParams));
        } else {
          window.webkit.messageHandlers.confirmOrder.postMessage(
            JSON.stringify(appBookParams)
          );
        }
      } else {
        // 跳转确认订单页
        this.$router.push({
          name: "CourseConfirmOrder",
          params: information,
        });
      }
    },
    // 视频点击
    videoClick(item) {
      // 当用户购买之后点击课程目录在播放视频
      if (this.isUserExist === 1) {
        if (item.videoId) {
          this.activeVideo = item.key;
          this.getPlayInfos(item.videoId);
          this.player.dispose();
        }
      }
    },
    //点击下载
    async downloadFile(url, name) {
      if(!sessionStorage.getItem("token")) {
        if (this.$route.query.out) {
          if (this.$global.isAndroid_ios()) {
            window.android.getToken();
          } else {
            window.webkit.messageHandlers.getToken.postMessage("null"); //ios
          }
        } else {
          // 如果未登录，跳转登录页
          // 记录源网页，登录成功之后跳转回当前页面
          this.$router.push("/logins");
        }
      }
      // 判断是否已报名
      if (this.isUserExist !== 1) {
        Toast('报名后可下载课程资料');
        return;
      }
      if (this.$route.query.out) {
        if (this.$global.isAndroid_ios()) {
          window.android.downloadUrl(
            this.$apis.mainServe.downloads +
              "?fileUrl=" +
              url +
              "&fileName=" +
              name
          );
        } else {
          window.webkit.messageHandlers.downloadUrl.postMessage(
            this.$apis.mainServe.downloads +
              "?fileUrl=" +
              url +
              "&fileName=" +
              name
          ); //ios
        }
      } else {
        // H5下载
        window.open(
          this.$apis.mainServe.downloads +
            "?fileUrl=" +
            url +
            "&fileName=" +
            name
        );
      }
    },
    // 获取作者
    getUser(type, userId, companyId) {
      this.$apis.recomendServe
        .getAuthor({
          type,
          userId,
          companyId: companyId ? companyId : "",
        })
        .then((res) => {
          this.business = res.content;
        });
    },
    jump() {
      let out = this.$route.query.out;
      if (this.userType === 2) {
        this.$router.push({
          path: "/appusesjigou",
          query: {
            item: 2,
            id: this.companyId,
            out,
          },
        });
      } else if (this.userType === 1) {
        this.$router.push({
          path: "/appusesbaike",
          query: {
            item: 1,
            id: this.companyId,
            out,
          },
        });
      }
    },
    otherDetails(id) {
      let out = this.$route.query.out;
      this.$router.push({
        path: "/courseDetails",
        query: {
          goodsId: id,
          out,
        },
      });
    },
    // 更新sku弹窗的显示状态
    updateSkuPannelStatus(status) {
      this.showSku = status;
    },
    // 点击课程讲师跳转学者号
    committeeMember(id) {
      let out = this.$route.query.out;
      this.$router.push({
        path: "/appusesbaijia",
        query: {
          item: 0,
          id: id,
          out,
        },
      });
    },

    /* 海报内容相关 */
    // 海报分享
    sharePoster(showStatus, isExtend = false) {
      this.showPoster = showStatus;
      if (showStatus) {
        this.$nextTick(() => {
          this.drawPoster(isExtend);
        });
      }
    },

    // 二维码
    createQrCode(isExtend) {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // 清空二维码,创建新的二维码
      this.qrcode = null;
      this.$refs["qrcode"].innerHTML = "";
      let text = `${location.href}${
        isExtend ? "&promoterId=" + userInfo.promoterId : ""
      }`;
      this.qrcode = new QRCode("qrcode", {
        width: 55 * 3,
        height: 55 * 3,
        text,
        correctLevel: QRCode.CorrectLevel.H,
      });
    },

    // html to canvas
    drawPoster(isExtend) {
      const _this = this;
      _this.createQrCode(isExtend);
      let scale = window.devicePixelRatio;
      html2canvas(document.querySelector("#poster-dom"), {
        useCORS: true,
        scrollY: 0,
        scrollX: 0,
        // width: 315,
        // height: 356,
        x: 0,
        y: 0,
        backgroundColor: "transparent",
        scale: scale ? scale : 1,
        windowWidth: Window.innerWidth,
        windowHeight: Window.innerHeight,
      }).then(function (canvas) {
        _this.posterUrl = canvas.toDataURL("image/png");
      });
    },
    // 关闭海报遮罩
    restorePageScroll() {
      this.showPoster = false;
      // 回到页面内，页面顶部导航栏状态恢复
      setTimeout(() => {
        this.$bus.$emit("posterVisibleStatus", this.showPoster);
      }, 500);
    },
    // 为课程列表加Key
    setKey(arr) {
      arr.map((item1, i) => {
        item1.key = i + 1 + '';
        if (item1.childrenList && item1.childrenList.length) {
          item1.childrenList.map((item2, j) => {
            item2.key = item1.key + '-' + (j + 1);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.courseDetails {
  background: #f5f5f5;
  position: relative;
  // padding-bottom: 50px;
  // padding-top: 44px;

  // 下架样式
  .shelves-box {
    height: calc(100vh - 61px);
  }
  // 1.顶部图片
  .top-img {
    width: 100%;
    height: 211px;
    position: fixed;
    top: calc(env(safe-area-inset-top) + 44px);
    top: calc(cconstant(safe-area-inset-top) + 44px);
  }

  .img {
    width: 100%;
    height: 211px;

    img {
      width: 100%;
      height: 211px;
    }
  }
  .playheight {
    margin-top: calc(env(safe-area-inset-top) + 330px) !important;
    margin-top: calc(cconstant(safe-area-inset-top) + 330px) !important;
  }

  // 2.主体内容区域
  .content {
    margin: 12px;

    // 各个内容分区通用样式
    .content-box {
      padding: 12px;
      margin-bottom: 12px;
      background: #fff;
      border-radius: 8px;

      //   各个内容分区顶部名称字体样式
      h1 {
        font-size: 17px;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
      }
    }

    .meeting-info {
      .price {
        font-size: 16px;
        color: #ff3d3d;
        line-height: 17px;
      }

      .title {
        font-size: 17px;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
        margin: 12px 0;
      }

      .time,
      .address {
        font-size: 13px;
        color: #999999;
        height: 19px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 12px;

        img {
          width: 13px;
          height: 13px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }

      .address {
        img {
          width: 11px;
          height: 15px;
          margin-right: 11px;
        }
      }
    }

    .detail-info {
      &::v-deep .detail-info-box {
        border-radius: 6px;
        margin-top: 16px;

        // 处理富文本编辑器中添加表格之类的内容，浮动显示影响布局
        overflow: hidden;

        img,
        video {
          max-width: 100% !important;
          height: auto !important;
        }
      }
    }

    .directory {
      .video-item {
        width: 100%;
        line-height: 40px;
        cursor: pointer;
        color: #969799;
      }
      .is-active {
        color: #4a79f1;
      }
      .tabulation {
        display: flex;
        border-bottom: 1px solid #eeeeee;

        .directory_list {
          height: 42px;
          line-height: 42px;
          width: 280px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .directory_lists {
          color: #4a79f1;
          height: 42px;
          line-height: 42px;
          width: 280px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .play {
          font-size: 11px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #4a79f1;
          width: 45px;
          height: 19px;
          background: #f1f5ff;
          border-radius: 3px;
          text-align: center;
          line-height: 18px;
          margin-top: 10px;
        }
      }

      .type {
        width: 15%;
        margin: 0 auto;
        text-align: center;
        margin-top: 13px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-bottom: 13px;

        img {
          width: 9px;
          height: 5px;
          margin-bottom: 3px;
        }
      }
    }

    .committee-info {
      .committee-member {
        margin-top: 20px;

        .member-basic-info {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          img {
            width: 45px;
            height: 45px;
            border-radius: 50%;
            margin-right: 12px;
          }

          .member-name {
            font-size: 15px;
            font-weight: 500;
            color: #333333;
            line-height: 21px;
            margin-right: 12px;
          }

          .member-title {
            background: rgba(74, 121, 241, 0.1);
            border-radius: 3px;
            font-size: 12px;
            color: #4a79f1;
            line-height: 20px;
            padding: 2px 9px;
            margin-right: 8px;
          }

          .member-education-info {
            color: #999999;
            line-height: 19px;
            font-size: 13px;
            margin-top: 10px;
          }
        }

        .member-intro {
          margin-top: 12px;
          width: 100%;
          max-height: 68px;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          color: #333333;
          line-height: 23px;
        }
      }
    }

    .conference-proceedings {
      li {
        margin-top: 13px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .college-of-finance {
      display: flex;
      align-items: center;
      height: 70px;

      img {
        width: 50px;
        height: 47px;
      }

      .businessName {
        width: 210px;
        margin-left: 10px;
      }

      button {
        width: 60px;
        height: 30px;
        background: #4a79f1;
        border-radius: 15px;
        font-size: 14px;
        color: #fff;
        border: 0;
      }
    }

    .other {
      .course_list {
        display: inline-block;
        margin: 12px 0px 0 0px;
        width: 155px;
        height: 198px;
        border-radius: 6px;
        background-color: #fff;
        overflow: hidden;
        border: 1px solid #eeeeee;

        &:nth-child(2n) {
          margin-left: 1px;
          margin-right: 11px;
        }

        .px-cover-img {
          width: 100%;
          height: 88px;
        }

        .px-content {
          padding: 0 10px;

          .px-title {
            font-size: 14px;
            color: #333333;
            line-height: 20px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .px-address {
            margin: 10px 0 14px;

            img {
              margin-right: 4px;
              width: 12px;
              height: 12px;
              vertical-align: middle;
            }

            span {
              display: inline-block;
              width: 85%;
              font-size: 12px;
              color: #9c9c9c;
              line-height: 17px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              vertical-align: middle;
            }
          }

          .px-info {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .price {
              font-size: 15px;
              font-weight: 700;
              color: #ff0054;
            }

            .isSign {
              font-size: 11px;
              color: #999999;
            }
          }
        }
      }
    }
  }

  .empty-data {
    text-align: center;

    .zanwu-img {
      width: 15%;
    }
  }
}
</style>
<style lang="scss">
@import "~@/assets/styles/poster.scss";
</style>